<template>
  <div class="base">
    <v-alert class="mb-4" value="true" type="info">
      Der Speichenrechner ist aktuell nur in einer Beta Version vorhanden, er rechnet richtig. Jedoch sind die Daten noch nicht vollständig gepflegt, wodurch es hier zu Fehlern kommen kann
    </v-alert>
    <v-layout wrap justify-center>
      <v-flex xs12 sm6>
        <v-card class="calc-card" max-width="400px">
          <v-img
            class="white--text"
            height="200px"
            gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
            src="/static/img/spoke/hub.JPG"/>
          <v-card-title><h2>{{$vuetify.t('$vuetify.spoke.hub_title')}}</h2></v-card-title>
          <v-card-text>
            <v-autocomplete :label="$vuetify.t('$vuetify.spoke.hub_manufacturers_select')" :loading="hubLoading" :items="hubManufacturers" @change="fetchHubs" return-json
                            item-text="name"
                            item-value="id"></v-autocomplete>

            <v-autocomplete :label="$vuetify.t('$vuetify.spoke.hub_select_title')" :items="hubs" :loading="calcLoading" @change="calc" v-model="selectedHub" return-object
                            item-text="model" item-value="id">
              <template v-slot:item="data">
                <p v-if="data.item">
                  {{ data.item.model }} ({{$vuetify.t(data.item.rear ? '$vuetify.spoke.hub_rear' : '$vuetify.spoke.hub_front')}})
                </p>
              </template>
            </v-autocomplete>

            <hub-display :hub="selectedHub"></hub-display>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6>
        <v-card class="calc-card" max-width="400px">
          <v-img
            class="white--text"
            height="200px"
            gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
            src="/static/img/spoke/rim.JPG"/>
          <v-card-title><h2>{{$vuetify.t('$vuetify.spoke.rim_title')}}</h2></v-card-title>
          <v-card-text>
            <v-autocomplete :label="$vuetify.t('$vuetify.spoke.rim_manufacturers_select')" :loading="rimLoading" :items="rimManufacturers" @change="fetchRims" return-json
                            item-text="name"
                            item-value="id"></v-autocomplete>

            <v-autocomplete :label="$vuetify.t('$vuetify.spoke.rim_select_title')" :items="rims" :loading="calcLoading" @change="calc" v-model="selectedRim" return-object
                            item-text="model" item-value="id">
              <template v-slot:item="data">
                <p v-if="data.item">
                  {{ data.item.model }} ({{$vuetify.t(data.item.rear ? '$vuetify.spoke.hub_rear' : '$vuetify.spoke.hub_front')}})
                </p>
              </template></v-autocomplete>

            <rim-display :rim="selectedRim"></rim-display>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-card>
        <v-card-title><h2>{{$vuetify.t('$vuetify.spoke.result_title')}}</h2></v-card-title>
        <v-card-text>
          <v-layout justify-center wrap>
            <v-select class="small-element ma-3" :label="$vuetify.t('$vuetify.spoke.spoke_count')" :items="[16,20,24,28,32,36,40]" v-model="spokeCount"></v-select>
            <v-text-field class="small-element ma-3" :label="$vuetify.t('$vuetify.spoke.spoke_crossing')" v-model="spokeCrossing" type="number"></v-text-field>
          </v-layout>
          <div class="result-container">
            <div class="result-element">
              <h4>{{$vuetify.t('$vuetify.spoke.spoke_length_left')}}</h4>
              <div>
                {{resultSpokeLeft}} mm<br>
                <span class="mmmm">{{$vuetify.t('$vuetify.spoke.exact')}}</span>
              </div>
              <div>
                {{resultSpokeLeftRounded}} mm<br>
                <span>{{$vuetify.t('$vuetify.spoke.recommended')}}</span>
              </div>
            </div>
            <div class="result-element">
              <h4>{{$vuetify.t('$vuetify.spoke.spoke_length_left')}}</h4>
              <div>
                {{resultSpokeRight}} mm<br>
                <span>{{$vuetify.t('$vuetify.spoke.exact')}}</span>
              </div>
              <div>
                {{resultSpokeRightRounded}} mm<br>
                <span>{{$vuetify.t('$vuetify.spoke.recommended')}}</span>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
  import StringMixinx from '../mixins/StringMixin'
  import {eventBus} from '../main';
  import HubDisplay from '../components/hub-display'
  import RimDisplay from '../components/rim-display'

  export default {
    mixins: [StringMixinx],
    name: 'SpokeCalculator',
    components: {HubDisplay, RimDisplay},
    created() {
      eventBus.$emit('title-change', this.$vuetify.t('$vuetify.spoke.title'));

      this.fetchData();
    },
    data() {
      return {
        rimLoading: false,
        hubLoading: false,
        calcLoading: false,
        resultSpokeLeft: '--',
        resultSpokeRight: '--',
        resultSpokeLeftRounded: '--',
        resultSpokeRightRounded: '--',
        hubManufacturers: [],
        hubs: [],
        rimManufacturers: [],
        rims: [],
        selectedHub: null,
        selectedRim: null,
        spokeCount: 32,
        spokeCrossing: 3
      }
    },
    methods: {
      fetchData() {
        fetch('https://wsf-be.die-gestalten.net/mybikesetup/wheels/hubs/manufacturers').then(response => response.ok ? response.json() : alert('mist')).then(json => {
          this.hubManufacturers = json.manufacturers;
          // this.hubs = json.hubs;
        });
        fetch('https://wsf-be.die-gestalten.net/mybikesetup/wheels/rims/manufacturers').then(response => response.ok ? response.json() : alert('mist')).then(json => {
          this.rimManufacturers = json.manufacturers;
          // this.rims = json.rims;
        });
      },
      fetchHubs(manuId) {
        this.hubLoading = true;
        fetch('https://wsf-be.die-gestalten.net/mybikesetup/wheels/hubs/manufacturers/' + manuId).then(response => response.ok ? response.json() : alert('mist')).then(json => {
          this.hubs = json.hubs;
          this.hubLoading = false;
        });
      },
      fetchRims(manuId) {
        this.rimLoading = true;
        fetch('https://wsf-be.die-gestalten.net/mybikesetup/wheels/rims/manufacturers/' + manuId).then(response => response.ok ? response.json() : alert('mist')).then(json => {
          this.rims = json.rims;
          this.rimLoading = false;
        });
      },
      calc() {
        this.resultSpokeLeft = '--';
        this.resultSpokeRight = '--';
        this.resultSpokeLeftRounded = '--';
        this.resultSpokeRightRounded = '--';
        if (this.selectedHub != null && this.selectedRim != null) {
          this.calcLoading = true;
          fetch(`https://wsf-be.die-gestalten.net/mybikesetup/wheels/calc/hub/${this.selectedHub.id}/rim/${this.selectedRim.id}?spokeCount=${this.spokeCount}&spokeCrossing=${this.spokeCrossing}`)
            .then(response => response.ok ? response.json() : alert('mist')).then(json => {
            this.calcLoading = false;
            if (json.success) {
              this.resultSpokeLeft = json.result.spokeLengthLeft.toFixed(1);
              this.resultSpokeRight = json.result.spokeLengthRight.toFixed(1);
              this.resultSpokeLeftRounded = json.result.spokeLengthLeftRounded;
              this.resultSpokeRightRounded = json.result.spokeLengthRightRounded;
            }
          });
        }
      }
    }
  }
</script>

<style scoped>
  .base {
    max-width: 1000px;
  }

  .small-element {
    max-width: 100px;
  }

  .calc-card {
    margin: 0 auto 12px auto;
  }

  .result-container {
    display: flex;
  }

  .result-container .result-element {
    width: 150px;
    flex-shrink: 0;
  }

  .result-container .result-element:first-child {
    margin-left: auto;
  }

  .result-container .result-element:last-child {
    margin-right: auto;
  }

  .result-container .result-element span {
    font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/views/SpokeCalculator.vue